export const getAssigmentsByUser = (data) => {
  let users = [];
  let schools = [];
  let user = {};
  let lastuser = '';
  let active = 0;
  let finished = 0;

  data.forEach((row) => {
    if (row.user_id !== lastuser) {
      if (lastuser !== '') {
        user.schools = schools;
        user.active = active;
        user.finished = finished;
        users.push(user);
        schools = [];
        active = 0;
        finished = 0;
      }
      user = {
        user_id: row.user_id,
        first_name: row.first_name,
        last_name: row.last_name,
        email: row.email,
        user: `${row.first_name} ${row.last_name}`,
        role_id: row.role_id,
        user_status: row.user_status,
        cloudtalk_id: row.cloudtalk_id,
      };

      lastuser = row.user_id;
    }
    if (row.school_id) {
      if (row.status === 'active') active++;
      if (row.status === 'finished') finished++;

      schools.push({
        user: `${row.first_name} ${row.last_name}`,
        user_id: row.user_id,
        school_id: row.school_id,
        school_name: row.school_name,
        status: row.status,
        begin_at: row.begin_at,
        end_at: row.end_at,
        assignment_id: row.assignment_id,
      });
    }
  });
  if (lastuser !== '') {
    user.schools = schools;
    user.active = active;
    user.finished = finished;
    users.push(user);
  }

  return users;
};
